import * as Sentry from '@sentry/browser';

export default function(Vue) {
  Vue.prototype.$sendErr = function(err, options = {}) {
    if (!err) return;

    const defaultOptions = {
      user: null,
      tag: null,
      info: null,
      level: 'error',
    };

    const config = Object.assign({}, defaultOptions, options);

    Sentry.withScope(scope => {
      if (config.tag) {
        if (typeof config.tag === 'object') {
          for (let k in config.tag) {
            scope.setTag(k, config.tag[k]);
          }
        }
      }
      if (config.user) {
        scope.setUser(config.user);
      }
      if (config.level) {
        scope.setLevel(config.level);
      }
      if (config.info) {
        if (typeof config.info === 'object') {
          for (let k in config.info) {
            scope.setExtra(k, config.info[k]);
          }
        }
      }
      // 根据err.message对错误进行分组
      scope.setFingerprint(['{{ default }}', String(err.message)]);
      Sentry.captureException(err);
    });
  };
}
